import styled from "styled-components";
import { GizmoContainerResize } from "../../utils";

const Folio = styled(GizmoContainerResize)`
  // border: 2px dashed yellow;
`;

export { Folio };
